var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3447 6.1362C23.5222 6.51004 22.6357 6.7557 21.7171 6.87319C22.6571 6.3071 23.3834 5.40989 23.7252 4.33111C22.8386 4.86516 21.856 5.239 20.8199 5.45262C19.9761 4.53405 18.7905 4 17.4447 4C14.9347 4 12.8839 6.05075 12.8839 8.58215C12.8839 8.9453 12.9267 9.29778 13.0014 9.62889C9.199 9.43663 5.81312 7.61018 3.55943 4.8438C3.16423 5.5167 2.93993 6.3071 2.93993 7.14022C2.93993 8.73168 3.741 10.1416 4.98 10.9427C4.22165 10.9427 3.5167 10.729 2.8972 10.4086C2.8972 10.4086 2.8972 10.4086 2.8972 10.4406C2.8972 12.6623 4.47799 14.5208 6.57147 14.9373C6.18695 15.0442 5.78108 15.0976 5.36452 15.0976C5.07613 15.0976 4.78774 15.0655 4.51004 15.0121C5.08681 16.8172 6.76373 18.163 8.78244 18.1951C7.22301 19.434 5.24703 20.1604 3.08946 20.1604C2.72631 20.1604 2.36315 20.139 2 20.0963C4.02939 21.3994 6.4433 22.1577 9.0281 22.1577C17.4447 22.1577 22.0696 15.1723 22.0696 9.1162C22.0696 8.91326 22.0696 8.721 22.0589 8.51806C22.9561 7.8772 23.7252 7.06545 24.3447 6.1362Z",
    fill: "#9096F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6dafbc4c81bf82aa3dee5501bac22402.svg";
export { ForwardRef as ReactComponent };